@app.directive 'searchTypeahead', (AlgoliaSearchService) ->
  restrict: 'E'
  scope: {
    customMethod: '@'
    select: '&onSelect'
  }
  link: (scope, element, attrs) ->

    scope.search = (query) ->
      params = {
        difficulty: 'any'
        generator: 'chefsteps'
        published_status: 'published'
        page: '1'
        search_all: query
        attributesToRetrieve: 'title,url,image,likes_count,description,activity_type,premium'
        sort: 'relevance'
      }

      AlgoliaSearchService.search(params).then (data) ->
        scope.searchResults = data

    scope.clear = ->
      scope.searchQuery = null
      scope.searchResults = []

  templateUrl: "/assets/templates/directives/searchTypeahead/searchTypeahead.html"
